/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { SyncFileBinaryIEnumerableResponse } from '../models';
import { SyncInvestigationIEnumerableResponse } from '../models';
import { SyncOtherIEnumerableResponse } from '../models';
import { SyncPracticeIEnumerableResponse } from '../models';
import { SyncStatusResponse } from '../models';
/**
 * SyncApi - axios parameter creator
 * @export
 */
export const SyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns SyncFileBinaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncFilesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/GetSyncFiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SyncInvestigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncInvestigationsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/GetSyncInvestigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SyncOthers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncOthersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/GetSyncOthers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SyncPractices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncPracticesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/GetSyncPractices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SyncStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/GetSyncStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value whether SyncOther is ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncIsSyncOtherReadyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Sync/IsSyncOtherReady`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncApi - functional programming interface
 * @export
 */
export const SyncApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns SyncFileBinaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncGetSyncFilesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncFileBinaryIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncGetSyncFilesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns SyncInvestigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncGetSyncInvestigationsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInvestigationIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncGetSyncInvestigationsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns SyncOthers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncGetSyncOthersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncOtherIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncGetSyncOthersGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns SyncPractices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncGetSyncPracticesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncPracticeIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncGetSyncPracticesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns SyncStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncGetSyncStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncStatusResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncGetSyncStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value whether SyncOther is ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SyncIsSyncOtherReadyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncApiAxiosParamCreator(configuration).apiV2SyncIsSyncOtherReadyGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SyncApi - factory interface
 * @export
 */
export const SyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns SyncFileBinaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncFilesGet(options?: any): AxiosPromise<SyncFileBinaryIEnumerableResponse> {
            return SyncApiFp(configuration).apiV2SyncGetSyncFilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SyncInvestigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncInvestigationsGet(options?: any): AxiosPromise<SyncInvestigationIEnumerableResponse> {
            return SyncApiFp(configuration).apiV2SyncGetSyncInvestigationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SyncOthers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncOthersGet(options?: any): AxiosPromise<SyncOtherIEnumerableResponse> {
            return SyncApiFp(configuration).apiV2SyncGetSyncOthersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SyncPractices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncPracticesGet(options?: any): AxiosPromise<SyncPracticeIEnumerableResponse> {
            return SyncApiFp(configuration).apiV2SyncGetSyncPracticesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SyncStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncGetSyncStatusGet(options?: any): AxiosPromise<SyncStatusResponse> {
            return SyncApiFp(configuration).apiV2SyncGetSyncStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value whether SyncOther is ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SyncIsSyncOtherReadyGet(options?: any): AxiosPromise<BooleanResponse> {
            return SyncApiFp(configuration).apiV2SyncIsSyncOtherReadyGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncApi - object-oriented interface
 * @export
 * @class SyncApi
 * @extends {BaseAPI}
 */
export class SyncApi extends BaseAPI {
    /**
     * 
     * @summary Returns SyncFileBinaries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncGetSyncFilesGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncGetSyncFilesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns SyncInvestigations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncGetSyncInvestigationsGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncGetSyncInvestigationsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns SyncOthers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncGetSyncOthersGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncGetSyncOthersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns SyncPractices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncGetSyncPracticesGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncGetSyncPracticesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns SyncStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncGetSyncStatusGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncGetSyncStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value whether SyncOther is ready
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public apiV2SyncIsSyncOtherReadyGet(options?: any) {
        return SyncApiFp(this.configuration).apiV2SyncIsSyncOtherReadyGet(options).then((request) => request(this.axios, this.basePath));
    }
}
